import './ModalWindow.css';
import { useUI } from '../../hooks/useUI';
import { resources } from '../../utils/resources';

const ModalWindow = (props) => {
    const { closeModal, isModalOpen, userData } = useUI();

    const handleClose = () => {
        closeModal('modalWindow');
        if (props.onClose) {
            props.onClose(); // Вызываем onClose для увеличения счётчика в WalletsPage
        }
    };

    return (
        <div className={isModalOpen ? `modalWindow active` : `modalWindow`}>
            <div className={isModalOpen ? `modalWindow__block active` : `modalWindow__block`}>
                <div className="modalWindow__blockTop">
                    <div className="modalWindow__title appearanceAnimation">{props.title}</div>
                    {userData.user_wallets.length > 0 ? (
                        <button
                            style={{ backgroundImage: `url(${resources.icons.close})` }}
                            className="modalWindow__btnClose"
                            onClick={handleClose}
                        ></button>
                    ) : (
                        <></>
                    )}
                </div>
                <div className="modalWindow__content">
                    {props.content}
                </div>
            </div>
        </div>
    );
};

export default ModalWindow;